import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

const PLACEHOLDER_PREFIX = '__FILL';

let agent = null;

const getApiOrigins = () => (process.env.REACT_APP_API_ORIGINS || '')
  .split(',')
  .map(origin => origin.trim())
  .filter(Boolean);

export function initializeNewRelic() {
  if (agent) return;

  if (process.env.REACT_APP_NEWRELIC_ENABLED === 'false') {
    console.info('[newrelic] disabled via REACT_APP_NEWRELIC_ENABLED=false');
    return;
  }

  const licenseKey = process.env.REACT_APP_NEWRELIC_LICENSE_KEY;
  const applicationId = process.env.REACT_APP_NEWRELIC_APPLICATION_ID;
  const accountId = process.env.REACT_APP_NEWRELIC_ACCOUNT_ID;

  if (
    !licenseKey ||
    !applicationId ||
    !accountId ||
    licenseKey.startsWith(PLACEHOLDER_PREFIX) ||
    applicationId.startsWith(PLACEHOLDER_PREFIX)
  ) {
    console.info('[newrelic] skipping init — placeholder values, awaiting iac apply');
    return;
  }

  agent = new BrowserAgent({
    init: {
      distributed_tracing: {
        enabled: true,
        cors_use_newrelic_header: true,
        cors_use_tracecontext_headers: true,
        allowed_origins: getApiOrigins()
      },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ['bam.nr-data.net'] },
      jserrors: { enabled: true },
      page_view_timing: { enabled: true },
      page_action: { enabled: true },
      spa: { enabled: true },
      session_trace: { enabled: true },
      session_replay: {
        enabled: true,
        mask_all_inputs: true,
        mask_text_selector: '*',
        block_selector: '[data-nr-block]'
      },
      logging: { enabled: true }
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey,
      applicationID: applicationId,
      sa: 1
    },
    loader_config: {
      accountID: accountId,
      trustKey: accountId,
      agentID: applicationId,
      licenseKey,
      applicationID: applicationId
    }
  });
}

export function setNewRelicUser(userId, attrs = {}) {
  if (typeof window === 'undefined') return;
  const nr = window.newrelic;
  if (!nr) return;

  nr.setUserId(userId);
  Object.entries(attrs).forEach(([key, value]) => nr.setCustomAttribute(key, value));
}
